import type { AnalyticsOverview } from '@/types'

const day = (offset: number) => {
  const d = new Date(Date.now() - offset * 864e5)
  return d.toISOString().slice(0, 10)
}

// Deterministic pseudo-random so a reload does not reshuffle the chart.
const wobble = (i: number, base: number, spread: number) =>
  Math.round(base + Math.sin(i * 1.7) * spread + (i % 5) * (spread / 6))

export const analyticsOverview: AnalyticsOverview = {
  totalMeetings: 184,
  totalMinutes: 8_420,
  actionItemsCreated: 412,
  actionItemsCompleted: 288,
  avgMeetingMinutes: 46,
  trend: {
    totalMeetings: 0.12,
    totalMinutes: 0.08,
    actionItemsOpen: -0.06,
    avgMeetingMinutes: -0.04,
  },
  usage: Array.from({ length: 30 }, (_, i) => ({
    date: day(29 - i),
    minutes: Math.max(0, wobble(i, 280, 90)),
    meetings: Math.max(0, wobble(i, 6, 3)),
  })),
  talkTime: [
    { participant: 'Varun Pandey', minutes: 1_420, share: 0.31 },
    { participant: 'Kareena Shah', minutes: 1_180, share: 0.26 },
    { participant: 'Khushi Verma', minutes: 820, share: 0.18 },
    { participant: 'Shivam Rao', minutes: 610, share: 0.13 },
    { participant: 'Neha Iyer', minutes: 380, share: 0.08 },
    { participant: 'Unattributed', minutes: 190, share: 0.04 },
  ],
  topicShare: [
    { topic: 'FMS migration', count: 42 },
    { topic: 'Hiring', count: 31 },
    { topic: 'Pricing', count: 24 },
    { topic: 'Support escalations', count: 19 },
    { topic: 'Roadmap', count: 14 },
  ],
  languageMix: [
    { language: 'en-IN', minutes: 6_100 },
    { language: 'hi-IN', minutes: 1_980 },
    { language: 'mr-IN', minutes: 340 },
  ],
}
